module.exports = __webpack_public_path__ + "img/升压一体机.d3bcc32f.png";